var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01034 4.5L5.50775 5.5V3M1 5.5C1 6.09095 1.1166 6.67611 1.34313 7.22208C1.56967 7.76804 1.90171 8.26412 2.32029 8.68198C2.73887 9.09984 3.2358 9.43131 3.78271 9.65746C4.32962 9.8836 4.91579 10 5.50775 10C6.09972 10 6.68589 9.8836 7.23279 9.65746C7.7797 9.43131 8.27663 9.09984 8.69521 8.68198C9.1138 8.26412 9.44584 7.76804 9.67237 7.22208C9.89891 6.67611 10.0155 6.09095 10.0155 5.5C10.0155 4.90905 9.89891 4.32389 9.67237 3.77792C9.44584 3.23196 9.1138 2.73588 8.69521 2.31802C8.27663 1.90016 7.7797 1.56869 7.23279 1.34254C6.68589 1.1164 6.09972 1 5.50775 1C4.91579 1 4.32962 1.1164 3.78271 1.34254C3.2358 1.56869 2.73887 1.90016 2.32029 2.31802C1.90171 2.73588 1.56967 3.23196 1.34313 3.77792C1.1166 4.32389 1 4.90905 1 5.5Z",
    stroke: "#161616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.988f4c750660b9f17d139492d22b8bcd.svg";
export { ForwardRef as ReactComponent };